import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';
import { Checkbox } from 'primeng/checkbox';
import { Fluid } from 'primeng/fluid';
import { CategoryWithdrawConfig } from '@/lib-backend';

/** Reusable, presentation-only editor for a CategoryWithdrawConfig. */
@Component({
    selector: 'app-category-withdraw-form',
    standalone: true,
    imports: [FormsModule, InputNumber, Checkbox, Fluid],
    templateUrl: './category-withdraw-form.html',
})
export class CategoryWithdrawForm {
    readonly value = model.required<CategoryWithdrawConfig>();
    readonly disabled = input<boolean>(false);

    protected setField<K extends keyof CategoryWithdrawConfig>(field: K, v: CategoryWithdrawConfig[K]): void {
        this.value.update(d => ({ ...d, [field]: v }));
    }
}
